export function getAuth0Url(userId) {
  const param = window.btoa(encodeURIComponent(userId));
  return `https://manage.auth0.com/dashboard/eu/b2g/users/${param}`;
}

export function isAnonUser(userId) {
  return userId.startsWith('anon|');
}
